import React from 'react';

const Banner = () => {
    return (
        <div>
            <img className='w-100' height={350} src="https://media.istockphoto.com/photos/robots-efficiently-sorting-hundreds-of-parcels-per-hourpallet-lifter-picture-id1313196952?k=20&m=1313196952&s=612x612&w=0&h=LpYVD-o5LbhAW603zRHpcSp3gPybRkWG7HVcMMneDGg=" alt="" />
        </div>
    );
};

export default Banner;